if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    const AUTOPLAY_INTERVAL = 4500;

    document.querySelectorAll('media-gallery').forEach((mediaGallery) => {
      const viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
      if (!viewer) return;

      const slides = Array.from(viewer.querySelectorAll('[id^="Slide-"][data-media-id]'));
      if (slides.length < 2) return;

      let timer = null;
      let stopped = false;

      const isVisible = () => mediaGallery.offsetParent !== null;

      const tick = () => {
        if (stopped || !isVisible() || typeof mediaGallery.setActiveMedia !== 'function') return;
        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const nextIndex = activeIndex === -1 ? 0 : (activeIndex + 1) % slides.length;
        mediaGallery.setActiveMedia(slides[nextIndex].dataset.mediaId, false);
      };

      const start = () => {
        if (stopped) return;
        clearInterval(timer);
        timer = setInterval(tick, AUTOPLAY_INTERVAL);
      };
      const pause = () => clearInterval(timer);
      const haltPermanently = () => {
        stopped = true;
        pause();
      };

      start();

      mediaGallery.addEventListener('mouseenter', pause);
      mediaGallery.addEventListener('mouseleave', start);
      mediaGallery.addEventListener('touchstart', haltPermanently, { once: true, passive: true });
      mediaGallery.querySelectorAll('button[name="previous"], button[name="next"]').forEach((btn) => {
        btn.addEventListener('click', haltPermanently);
      });
      mediaGallery.querySelectorAll('.thumbnail-list__item button').forEach((btn) => {
        btn.addEventListener('click', haltPermanently);
      });
    });
  });
}
